import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';
import styles from './FieldPhone.module.scss';

const FieldPhone = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'inviteFriend-form-phone',
    defaultMessage: 'Phone'
  });
  const placeholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [field, meta] = useField({name: 'phone'});

  return (
    <InputText
      {...field}
      {...meta}
      variant={'full'}
      id={field.name}
      label={labelText}
      defaultValue={field.value}
      placeholder={placeholder}
      customClassnames={{
        container: styles.container,
        input: styles.input
      }}
    />
  );
};

export default FieldPhone;
